<template>
  <div class="wrapper" v-if="src">
    <h3>{{ header }}</h3>
    <cropper
      class="cropper"
      ref="cropper"
      :src="getImgProxySrc(src)"
      :stencil-props="{
        handlers: {},
        movable: false,
        scalable: false
      }"
      :stencil-size="stencilSize"
      :default-position="defaultPosition"
      :stencilComponent="stencilComponent"
      image-restriction="stencil"
      @change="cropChange"
    />
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { getImgProxySrc } from '../../common/js/imgproxy'

export default {
  components: {
    Cropper
  },
  props: {
    value: {
      type: [File, String],
      required: false
    },
    header: {
      type: String
    },
    src: {
      type: String,
      required: false
    },
    cropType: {
      type: String,
      required: false
    },
    cropTop: {
      type: Number,
      required: false
    },
    cropLeft: {
      type: Number,
      required: false
    },
    cropWidth: {
      type: Number,
      required: false
    },
    cropHeight: {
      type: Number,
      required: false
    },
    stencilWidth: {},
    stencilHeight: {},
    stencilComponent: {
      type: String,
      default: 'rectangle-stencil'
    }
  },
  methods: {
    getImgProxySrc,
    cropChange({ coordinates, canvas }) {
      canvas.toBlob(blob => {
        const file = new File([blob], 'cropped.png')
        this.$emit('input', file)
        this.$emit('update:cropTop', parseInt(coordinates.top))
        this.$emit('update:cropLeft', parseInt(coordinates.left))
        this.$emit('update:cropWidth', parseInt(coordinates.width))
        this.$emit('update:cropHeight', parseInt(coordinates.height))
      })
    }
  },
  computed: {
    defaultPosition() {
      return {
        top: this.cropTop,
        left: this.cropLeft,
        width: this.cropWidth,
        height: this.cropHeight
      }
    },
    stencilSize() {
      return {
        width: this.stencilWidth,
        height: this.stencilHeight
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: inline-block;
  position: relative;
}
.cropper {
  margin-top: 20px;
  margin-right: 20px;
  height: 300px;
  width: 300px;
  background: #ddd;
}
</style>
